/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ limit: NonNullable<unknown> }} Membership_Friend_Guest_DescriptionInputs */

const fr_membership_friend_guest_description = /** @type {(inputs: Membership_Friend_Guest_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.limit} ami(s) par mois calendaire. Vous pouvez annuler jusqu'au jour de sa venue.`)
};

/**

* @param {Membership_Friend_Guest_DescriptionInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_friend_guest_description = /** @type {((inputs: Membership_Friend_Guest_DescriptionInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Friend_Guest_DescriptionInputs, { locale?: "fr" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_friend_guest_description(inputs)
});